






















































import { Component, Vue, Prop } from "vue-property-decorator";
import axios from "axios";
import { General } from "@/services/General";
import { Sign } from "@/entity/Sign";
import { SignStatus } from "@/services/Enums";

@Component
export default class GarageSignStatusChange extends Vue {
  @Prop({ type: Number, required: false })
  status;
  @Prop({ required: false })
  sign;

  signLoaded: Sign = new Sign();
  loading: boolean = false;
  signStatusEnum: any = SignStatus;    
  isSaveClicked: boolean = false;

  returnState(condition: boolean, clickButton: boolean): boolean {
    if (clickButton) 
      return condition;
    else 
      return null;
  }

  async mounted() {
    this.signLoaded = this.sign;
  }

  async changeSignStatusDo(sign: Sign) {
    this.isSaveClicked = true;
    let formsValidation = true;
    let confirmMessage = "";
    switch (this.status) {
      case this.signStatusEnum.CONSEGNATA:
        confirmMessage = "Confermi la consegna dell'insegna?"
        if(!sign.dataConsegna)
          formsValidation = false;
        break;
      case this.signStatusEnum.RITIRATA:
        confirmMessage = "Confermi il ritiro / rimozione dell'insegna?"
        if(!sign.dataRimozione || !sign.dataRevoca)
          formsValidation = false;
        break;
      case this.signStatusEnum.ROTTAMATA:
        confirmMessage = "Confermi la rottamazione dell'insegna?"
        if(!sign.dataRimozione)
            formsValidation = false;
        break;
      case this.signStatusEnum.DANNEGGIATA:
        confirmMessage = "Confermi il danneggiamento dell'insegna?"
        if(!sign.dataDanneggiamento)
            formsValidation = false;
        break;
    }
    if(!formsValidation) {
      General.showAlertDanger("Verificare campi obbligatori", this);
    } else {
      General.confirm(
        confirmMessage,
        this,
        async () => {
          await this.changeSignStatus(sign);
        }
      );
    }
  } 

  async changeSignStatus(sign: Sign) {
    let successMessage = "";
    switch (this.status) {
      case this.signStatusEnum.CONSEGNATA:
        successMessage = "Insegna consegnata"
        break;
      case this.signStatusEnum.RITIRATA:
        successMessage = "Insegna ritirata / rimossa"
        break;
      case this.signStatusEnum.ROTTAMATA:
        successMessage = "Insegna rottamata"
        break;
      case this.signStatusEnum.DANNEGGIATA:
        successMessage = "Insegna danneggiata"
        break;
    }
    try {
      this.loading = true;
      await axios({
        method: "post",
        url: General.GetApiUrl("/api/sign/ChangeSignStatus?status=" + this.status),
        data: sign,
        withCredentials: true,
        responseType: "json",
      });
      General.showAlertSuccess(successMessage, this);
      this.closeDetailModal();
      this.$emit("actionOnSigns", sign, true);
    } catch (error) {
      General.HandleError(error, this);
    } finally {
      this.loading = false;
    }
  }

  closeDetailModal() {
    this.isSaveClicked = false;
    this.$bvModal.hide("garage-sign-status-modal");
  }
}
